import gql from 'graphql-tag';

export const publicIntegrationItemFragment = gql`
  fragment publicIntegrationItemFragment on PublicIntegrationItem {
    dokkioClass
    accountID
    integrationID
    remoteID
    name
    bytes
    integrationItemKind
    isThumbnailable
  }
`;
export default publicIntegrationItemFragment;
